import { ChangeEventHandler, useState } from "react";
import SANGJO_PRODUCTS from "@/constants/grouped_sangjo_products.json";

type RefundCalculatorForm = {
  sangjoId: keyof typeof SANGJO_PRODUCTS | "";
  productId: string;
  paymentsCount: string;
};

interface UseRefundCalculatorFormArgs {
  defaultForm: RefundCalculatorForm;
}

export const useRefundCalculatorForm = ({ defaultForm }: UseRefundCalculatorFormArgs) => {
  const [refundCalculatorForm, setRefundCalculatorForm] =
    useState<RefundCalculatorForm>(defaultForm);

  const resetRefundCalculatorForm = () => {
    setRefundCalculatorForm({ ...defaultForm });
  };

  const handleChange: ChangeEventHandler<HTMLInputElement | HTMLTextAreaElement> = (event) => {
    const { name, value } = event.target;

    if (name === "sangjoId") {
      setRefundCalculatorForm(() => ({
        ...defaultForm,
        [name]: value as keyof typeof SANGJO_PRODUCTS,
      }));

      return;
    }

    setRefundCalculatorForm((pre) => ({
      ...pre,
      [name]: String(value),
    }));
  };

  return {
    refundCalculatorForm,
    setRefundCalculatorForm,
    resetRefundCalculatorForm,
    handleChange,
  };
};
